/* eslint-disable @typescript-eslint/naming-convention */
export const CATEGORY = {
  1: {
    name: 'CATEGORY.HELP',
  },
  2: {
    name: 'CATEGORY.MAINTENANCE',
  },
  3: {
    name: 'CATEGORY.VERSION_UPGRADE',
  },
  4: {
    name: 'CATEGORY.OTHERS',
  },
};

export const CATEGORY_OPTIONS = [
  {
    name: 'CATEGORY.VERSION_UPGRADE',
    value: 3,
  },
  {
    name: 'CATEGORY.HELP',
    value: 1,
  },
  {
    name: 'CATEGORY.MAINTENANCE',
    value: 2,
  },
  {
    name: 'CATEGORY.OTHERS',
    value: 4,
  },
];
